import { useMutation, useQueryClient } from '@tanstack/react-query'

import { generateProforma } from '@flecto/api/shared'
import { type CoreDocumentProformaPayload } from '@flecto/types'

type MutationPayload = {
  bookingId: string
  proformaAttributes: CoreDocumentProformaPayload
}

export const useMutationGenerateProforma = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ bookingId, proformaAttributes }: MutationPayload) => {
      const response = await generateProforma(bookingId, proformaAttributes)
      queryClient.invalidateQueries(['QueryGetAllBookingDocuments'])
      return response
    },
    retry: 1,
  })
}
